import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnErrorIsSet,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { RmaApiParameter } from "@store/Services/EmailService";
import { rmaRequestSubmit } from "@store/Services/RmaRequestService";
import { RmaAttachedFileModel, RmaLineModel, RmaModel } from "@store/Types/ApiModels";

type RmaRequestParameter = {
    rmaNotes: string;
    rmaLineModels: RmaLineModel[];
    rmaAttachedFiles: RmaAttachedFileModel[];
    onError?: (errorMessage: string) => void;
} & HasOnSuccess<RmaModel>;

type HandlerType = ApiHandlerDiscreteParameter<RmaRequestParameter, RmaApiParameter, ServiceResult<RmaModel>>;

export const DispatchBeginRmaRequest: HandlerType = props => {
    const dispatch: any = props.dispatch;
    dispatch({
        type: "Data/RmaRequest/BeginRmaRequest",
    });
};

export const PopulateApiParameter: HandlerType = props => {
    const rmaModel = {
        rmaNotes: props.parameter.rmaNotes,
        rmaLineModels: props.parameter.rmaLineModels,
        rmaAttachedFiles: props.parameter.rmaAttachedFiles,
    } as RmaModel;
    props.apiParameter = { rmaModel };
};

export const CallAddRmaApi: HandlerType = async props => {
    props.apiResult = await rmaRequestSubmit(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        markSkipOnCompleteIfOnSuccessIsSet(props);
        props.parameter.onSuccess?.(props.apiResult.result);
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        markSkipOnCompleteIfOnErrorIsSet(props);
        props.parameter.onError?.(props.apiResult.errorMessage);
    }
};

export const DispatchCompleteRmaRequest: HandlerType = props => {
    const dispatch: any = props.dispatch;
    dispatch({
        type: "Data/RmaRequest/CompleteRmaRequest",
        result: props.apiResult.successful ? props.apiResult.result : undefined,
    });
};

export const chain = [
    DispatchBeginRmaRequest,
    PopulateApiParameter,
    CallAddRmaApi,
    ExecuteOnSuccessCallback,
    ExecuteOnErrorCallback,
    DispatchCompleteRmaRequest,
];

const rmaRequest = createHandlerChainRunner(chain, "RmaRequest");
export default rmaRequest;
